import { ensureDefined, templateResolver } from '@avantia/client-and-server-utilities';
import { HpClaimsClientConfiguration } from '../../../config/configurationTypes';
import { HpImageButtonListControlProps } from '../../../engineClient/components/formControls/standard';
import { registerConfigurationAction } from '../../../engineClient/config/registerClientConfig';
import { HpClientQuestionData } from '../../../engineClient/types';
import { filterPolicyInstances } from '../../../tools/utilities';
import { PolicyInstancesCustomData, PolicyMap } from '../../../types/policyTypes';
import { questionIds } from '../../../types/questionConstants';
import { HpClaimsQuestionSetPageProps } from '../../questionSetForm/questionSetPageTypes';
import { WarningWidget } from './coverSummaryCustomControl';
import { SelectPolicyCustomControl } from './selectPolicyCustomControl';

let hpPhoneNumber: string;

registerConfigurationAction((config) => {
  ({ hpPhoneNumber } = config as HpClaimsClientConfiguration);
});

type PolicyInstancesCustomControlProps = HpImageButtonListControlProps;

export function PolicyInstancesCustomControl(props: PolicyInstancesCustomControlProps): JSX.Element | null {
  const { question, answers, pageProps } = props;
  const { policies } = pageProps as HpClaimsQuestionSetPageProps;
  const { data } = question;
  const { customData } = data as HpClientQuestionData;
  const { noPoliciesText, questionText } = customData as unknown as PolicyInstancesCustomData;
  const { lossDate: lossDateQuestionId } = questionIds;
  ensureDefined(noPoliciesText, 'noPoliciesText');
  let filteredPolicies: PolicyMap | null = null;
  const selectedDateAnswer = answers[lossDateQuestionId];
  const { customer } = selectedDateAnswer || {};
  const selectedDate = customer && new Date(customer as string);
  if (selectedDate) {
    filteredPolicies = filterPolicyInstances(policies, selectedDate);

    if (filteredPolicies) {
      const filteredPoliciesLength = Object.keys(filteredPolicies).length;

      if (!filteredPoliciesLength) {
        const updatedText = templateResolver(noPoliciesText, {
          hpPhoneNumber
        });
        return <WarningWidget warningText={updatedText} />;
      }
    }
  }

  return <SelectPolicyCustomControl {...props} questionText={questionText} policies={filteredPolicies || policies} />;
}
